import React from 'react';
import TulufaliLogo from '../Icons/tulufali_logo.svg';
import s from './Footer.module.scss';

const Footer = ({ centered }) => {
  return (
    <div className={`${s.footer} ${centered ? s.footerCentered : ''}`}>
      <div className={s.footerContent}>
        <img src={TulufaliLogo} alt="Tulu Fali" className={s.footerLogo} />
        <div className={s.footerText}>
          <span className={s.footerBrand}>
            Tulu Fali <span className={s.footerVersion}>2.0</span>
          </span>
          <span className={s.footerBy}>
            Created by{' '}
            <span className={s.footerOrg}>
              Badan Perencanaan Pembangunan dan Riset Daerah Kabupaten Rote Ndao
            </span>
          </span>
        </div>
      </div>
      <div className={s.footerAccent}>
        <span className={s.footerDot} />
        <span className={s.footerDot} />
        <span className={s.footerDot} />
      </div>
    </div>
  );
};

export default Footer;
